import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class ZaradaPoMenjacnici extends BaseEntity{
    constructor(){
        super();
    }

    Datum: NgbDate = null;
    Komitent: string = null;
    VrstaTroska: string = null;
    IznosZarada: number = null;
    IznosTrosak: number = null;
    Saldo: number = null;

    Deserialize(input:any){
        this.ID = input.ID;
        this.Datum = input.Datum;
        this.Komitent = input.Komitent;
        this.VrstaTroska = input.VrstaTroska;
        this.IznosZarada =  this.blankIfZero(input.IznosZarada);
        this.IznosTrosak =  this.blankIfZero(input.IznosTrosak);
        this.Saldo =  this.blankIfZero(input.Saldo);
        return this;
    }

    Serialize(input: ZaradaPoMenjacnici){
        return input;
    }

    blankIfZero(value){
        return value == 0 ? "" : value;
    }
}